import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css"; // ✅ palette + theme
import "./styles/index.css";  // ✅ reset
import App from "./App";
import { BrowserRouter } from "react-router-dom"; // ⬅️ Import router

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
